import React from 'react'


import { Control } from '../components/Styled';
import Dashboard from './Dashboard';
import MainRoute from '../Routes/MainRoute'
const Final = () => {
  return (
    <Control>
    <Dashboard/>
    <MainRoute/>
    </Control>
  )
}

export default Final